import { auth, userService } from '../../../services';
import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';

export const GET_MEMBERSHIPS_FOR_BOARD = 'GET_MEMBERSHIPS_FOR_BOARD';
export const  GET_MEMBERSHIPS_FOR_BOARD_COUNT = 'GET_MEMBERSHIPS_FOR_BOARD_COUNT';
export const  GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_SUCCESS = 'GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_SUCCESS';
export const  GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR = 'GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR';


export function fetchAllMembershipsForBoard(searchQuery) {
	return async function(dispatch) {
		dispatch(loader(true));
		await axios
				.get(`${ROOT_API_URL}/MembershipsForBoard/GetAllMemberships`, { headers: auth.authHeader(), params: {searchQuery: searchQuery || ""} })
				.then((response) => {
					dispatch({
						type: GET_MEMBERSHIPS_FOR_BOARD,
						payload: response.data.membershipsForBoard,
					});
					dispatch(loader(false));
				})
				.catch((error) => {
					var err = "Network Connection Error"; 
					dispatch(loader(false));		
					dispatch(toastr(true,err));
				});
	};
}

export function fetchMembershipsForBoardCount(searchQuery) {
	return async function(dispatch) {
		dispatch(loader(true));
		await axios
				.get(`${ROOT_API_URL}/MembershipsForBoard/GetAllMembershipsCount`, { headers: auth.authHeader(), params: {searchQuery: searchQuery || ""} })
				.then((response) => {
					dispatch({
						type: GET_MEMBERSHIPS_FOR_BOARD_COUNT,
						payload: response.data,
					});
					dispatch(loader(false));
				})
				.catch((error) => {
					var err = "Network Connection Error"; 
					dispatch(loader(false));		
					dispatch(toastr(true,err));
				});
	};
}

export function fetchMembershipsForBoardByPage(data) {
	return async (dispatch) => {
		if (!data || data.page === null || data.page === undefined || data.page < 0) {
			dispatch({
				type: GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR,
				payload: 'Missing required data'
			});
		}
        var url = `${ROOT_API_URL}/MembershipsForBoard/GetMembershipsByPage`;
		const options = { method: 'POST', headers: auth.authHeader() };
		// console.log({data});
        await axios.post(url, data, options)
            .then((res) => {
                //debugger;

                if (res && res.data && res.data.isSuccess) {
				    dispatch({
					    type: GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_SUCCESS,
					    payload: res.data.membershipsForBoard
				    });
			    } else {
				    dispatch({
					    type: GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR,
					    payload: res.data.message
				    });
			    }
            })
            .catch((res) => {
                // console.log(res);
                dispatch({
                    type: GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR,
                    payload: res.message
                });
            });
        ;
	};
}